export let RasterSamplingMode;(function(e){e["AREA"]="AREA";e["POINT"]="POINT"})(RasterSamplingMode||(RasterSamplingMode={}));